module.exports = __webpack_public_path__ + "img/Trustor.9737d901.png";